import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MODE_ADD, MODE_EDIT, MODE_UNKNOWN, DEFAULT_IP } from "app/utils/constant";
import { cmnAssignFromBase, cmnSetValByPath } from "app/utils/utils";
import axios from "axios";

export const initialCampaignBasicInfo = {
    "campaign_name": {
        "zh": "",
        "en": ""
    },
    "campaign_sub_name": {
        "zh": "",
        "en": ""
    },
    "campaign_inquiry": {
        "admin_id": ""
    },
    "campaign_type_id": "",
    "campaign_intr": {
        "zh": "",
        "en": ""
    },
    "campaign_venue": "",
    "campaign_prices": [],
    "listCousre": [],
    "campaign_quota": 1,
    "campaign_enrolment_method": 1,
    "campaign_target_audience": 1,
    "campaign_code": "",
    "campaign_status": 0,
    "is_publish": false,
    "campaign_id": "",
    "campaign_type_id": "",
    "campaign_tutor": "",
    "is_available_regist": false
};

export const initalCampaignBasicInfoPrice = {
    "price": 0,
    "Label": {
        "zh": "",
        "en": ""
    },
    "audience_id": ""
}

export const initalCampaignLesson = {
    "campaign_id": "",
    "course_list": []
}

export const initalCampaignLessonItem = {
    "course_name": {
        "zh": "",
        "en": ""
    },
    "course_status": 1,
    "venue_id": "",
    "course_start_time": "",
    "course_end_time": "",
    // "campaign_medias": [],
    // "campaign_intr" : {
    //     "zh": "",
    //     "en": ""
    // },
    // "course_tutor": "",
    "f_date": "",
    "f_starttime": "",
    "f_endtime": "",
    "f_modified": true
}

export const initalCampaignFiles = {
    "campaign_id": "",
    "campaign_medias": [],
    "campaign_icon": ""
};

export const initalCampaignMedia = {
    "type": "",
    "url": ""
};

export const campaignStatusMap = {
    0: "cmpgnStatusDraft",
    1: "normal",
    2: "delayed",
    3: "cancelled",
};

const initialState = {
    campaignList: [],
    campaignEditMode: MODE_UNKNOWN,
    campaignEditData: {},
    editBasic: initialCampaignBasicInfo,
    editFiles: initalCampaignFiles,
    pageModifeid: false
};

export const searchCampaignsByPage = (page, sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(searchCampaignsByPageReq({ page: page, data: sendData }));

    commonHandleError(thunkResult.payload, callback);
};

export const uploadCampaignImage = (file, callback) => async (dispatch) => {
    const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/getuploadfileurl",
        {
            "usage": "campaign",
            "file": file.name
        });

    let data = postRes.data;

    if (1 == data?.code) {
        let putUrl = data.data.image_upload_url;
        let realImgUrl = data.data.image_url;
        let mimeType = file.type;
        let type = (mimeType.includes("image")) ? "image" : "video";
        let subName = file.name.substring(file.name.indexOf(".") + ".".length);

        let xhr = new XMLHttpRequest();
        xhr.open("PUT", putUrl, true);
        xhr.setRequestHeader("Content-Type", type + "/" + subName);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    callback(realImgUrl, "");
                } else {
                    callback(null, "upload failed:,", xhr.status, xhr.responseText);
                }
            }
        };

        xhr.send(file);
    } else {
        if (!data) {
            callback(null, "upload failed: no data");
        }
        else {
            callback(null, "upload failed, code:" + data.code + " message:" + data.message_en);
        }
    }
};

export const uploadCampaignImageBunch = (fileObj, callback) => async (dispatch) => {
    const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/getuploadfileurl",
        {
            "usage": "campaign",
            "file": fileObj.file.name
        });

    let data = postRes.data;

    if (1 == data?.code) {
        let putUrl = data.data.image_upload_url;
        let realImgUrl = data.data.image_url;
        let mimeType = fileObj.file.type;
        let type = (mimeType.includes("image")) ? "image" : "video";
        let subName = fileObj.file.name.substring(fileObj.file.name.indexOf(".") + ".".length);

        fileObj.type = type;

        let xhr = new XMLHttpRequest();
        xhr.open("PUT", putUrl, true);
        xhr.setRequestHeader("Content-Type", type + "/" + subName);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    fileObj.fileSrcUrl = realImgUrl;
                    callback(fileObj, "upload success");
                } else {
                    callback(null, "upload failed:,", xhr.status, xhr.responseText);
                }
            }
        };

        xhr.send(fileObj.file);
    } else {
        if (!data) {
            callback(null, "upload failed: no data");
        }
        else {
            callback(null, "upload failed, code:" + data.code + " message:" + data.message_en);
        }
    }
};

export const getCampaignDetail = (campaignId, callback) => async (dispatch) => {
    let thunkResult;
    if (!campaignId) {
        let action = createAction("mCampaignReq/tknAware/getCampaignDetail/fulfilled");
        let simulateResp = {
            "code": 1,
            "data": {}
        };

        thunkResult = await dispatch(action(simulateResp));
    } else {
        let sendData = {
            "campaign_id": campaignId
        };

        thunkResult = await dispatch(getCampaignDetailReq(sendData));
    }

    commonHandleError(thunkResult.payload, callback);
};


export const getCampaignsByPage = (page, callback) => async (dispatch) => {
    const thunkResult = await dispatch(getCampaignsByPageReq(page));
    commonHandleError(thunkResult.payload, callback);
}

export const createCampaign = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(createCampaignReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const updateCampaign = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(updateCampaignReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const deleteCampaign = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(deleteCampaignReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const updateMediaFiles = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(updateMediaFilesReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const publishCampaign = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(publishCampaignReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const unPublishCampaign = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(unPublishCampaignReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

const getCampaignsByPageReq = createAsyncThunk("mCampaignReq/tknAware/getCampaignsByPage", async (page) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/getcampaignlistv2?page=" + page, {});
    return res.data;
});

const searchCampaignsByPageReq = createAsyncThunk("mCampaignReq/tknAware/searchCampaignsByPage", async (obj) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/searchcampaign?page=" + obj.page, obj.data);
    return res.data;
});

const createCampaignReq = createAsyncThunk("mCampaignReq/tknAware/createCampaign", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/createcampaign", data);
    // const res = await axios.post("http://localhost:3007/createCampaign", data);
    return res.data;
});

const updateCampaignReq = createAsyncThunk("mCampaignReq/tknAware/updateCampaign", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/updatecampaignbasic", data);
    // const res = await axios.post("http://localhost:3007/updateCampaign", data);
    return res.data;
});

const updateMediaFilesReq = createAsyncThunk("mCampaignReq/tknAware/updateMediaFiles", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/updatefileupload", data);
    return res.data;
});

const getCampaignDetailReq = createAsyncThunk("mCampaignReq/tknAware/getCampaignDetail", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/getcampaigndetail", data);
    return res.data;
});

const deleteCampaignReq = createAsyncThunk("mCampaignReq/tknAware/deleteCampaign", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/deletecampaign", data);
    return res.data;
});

const publishCampaignReq = createAsyncThunk("mCampaignReq/tknAware/publishCampaign", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/publishcampaign", data);
    // const res = await axios.post("http://localhost:3007/publishcampaign", data);
    return res.data;
});

const unPublishCampaignReq = createAsyncThunk("mCampaignReq/tknAware/unPublishCampaign", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/withdrawcampaign", data);
    // const res = await axios.post("http://localhost:3007/unpublishcampaign", data);
    return res.data;
});
const commonHandleError = (data, callback) => {
    if (callback) {
        let baseErrorMsgObj = {
            message: "系統發生問題, 請稍後再試",
            message_en: "An unexpected error occurred. Please try again."
        }

        if (1 == data?.code) {
            callback(true, data);
        } else {
            callback(false, (data) ? (data) : (baseErrorMsgObj))
        }
    }
};



const rdxCampaignSlice = createSlice({
    initialState,
    name: "rdxCampaign",
    extraReducers: (builder) => {
        builder
            .addCase(getCampaignsByPageReq.fulfilled, (state, actions) => { })
            .addCase(searchCampaignsByPageReq.fulfilled, (state, actions) => { })
            .addCase(getCampaignDetailReq.fulfilled, (state, actions) => {
                let data = actions.payload;
                if (data.code === 1) {
                    let origCampaignData = data.data;

                    //TODO 錯別字 patch 'listCou'sr'e'
                    if (origCampaignData.listCousre && origCampaignData.listCousre.length > 0) {
                        origCampaignData.course_list = origCampaignData.listCousre;
                    } else if (origCampaignData.listCourse && origCampaignData.listCourse.length > 0) {
                        origCampaignData.course_list = origCampaignData.listCourse;
                    } else {
                        origCampaignData.course_list = [];
                    }

                    state.campaignEditData = origCampaignData;
                    if (!data.data.campaign_id) {
                        state.campaignEditMode = MODE_ADD;
                    } else {
                        state.campaignEditMode = MODE_EDIT;
                    }
                }
            })
    },
    reducers: {
        setCreateLoading(state, actions) {
            let { loading } = actions.payload;
            if (loading) {
                state.campaignEditMode = MODE_UNKNOWN;
            } else {
                state.campaignEditMode = MODE_ADD;
            }
        },
        setEditCampaignData(state, actions) {

        },
        clearEditCampaign(state) {
            state.campaignEditMode = MODE_UNKNOWN;
            state.campaignEditData = {};
            state.editBasic = initialCampaignBasicInfo;
        },
        resetAllCampaignPageData(state) {
            state = initialState;
        },
        setPageModified(state, actions) {
            state.pageModifeid = actions.payload;
        },
        initCampaignSimpleData(state, actions) {
            let { data, projection, type, noEmit } = actions.payload;

            if ("list" == type) {
                let resultData = (data) ? data : [];
                state[projection] = resultData;
            } else if ("obj" == type) {
                let base = {};
                switch (projection) {
                    case "editBasic": base = initialCampaignBasicInfo; break;
                    case "editFiles": base = initalCampaignFiles; break;
                    case "editLesson": base = initalCampaignLesson; break;
                }

                let obj = cmnAssignFromBase(base, data);
                state[projection] = obj;
            }

            if (!noEmit) {
                state.pageModifeid = false;
            }
        },
        setCampaignSimpleData(state, actions) {
            let { data, projection, path, noEmit } = actions.payload;

            if (Array.isArray(data) && !path) {
                state[projection] = data;
            } else {
                let formatPath;
                if (path.indexOf(projection) == 0) {
                    let headStr = projection + ".";
                    formatPath = path.substring(headStr.length);
                } else {
                    formatPath = path;
                }
                cmnSetValByPath(state[projection], formatPath, data);
            }

            if (!noEmit) {
                state.pageModifeid = true;
            }
        },
        setCampaignSimpleDataToCampaignData(state, actions) {
            let { data, projection, base, noEmit } = actions.payload;

            if (Array.isArray(data)) {
                // console.log("list update:", projection, data);
                state.campaignEditData[projection] = data;
            } else {
                let obj = Object.assign({}, base, data);
                if ("self" == projection) {
                    // console.log("self update:", projection, obj);
                    state.campaignEditData = obj;
                } else {
                    // console.log("partial update:", projection, obj);
                    state.campaignEditData[projection] = obj;
                }
            }

            if (!noEmit) {
                state.pageModifeid = false;
            }
        }
    }
});

export const {
    setCreateLoading,
    setEditCampaignData, clearEditCampaign, resetAllCampaignPageData,
    initCampaignSimpleData, setCampaignSimpleData, setCampaignSimpleDataToCampaignData,
    setPageModified } = rdxCampaignSlice.actions;

export const rdxCampaignReducer = rdxCampaignSlice.reducer;